/**
 * /operations/benefits-agent — Benefits agent (Pack 12 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function BenefitsAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Benefits Agent"
        subtitle="Tashghil drives enrollments; Mutaba'aa enforces CCHI + Article 144 health insurance floor; 4-agent death claim coordination."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil — enrollments</h3></div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Health insurance + dependent coverage</li>
          <li>Death beneficiary designation</li>
          <li>Education reimbursement claims</li>
          <li>Dependents allowance</li>
        </ul>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="mutabaa" /><h3 className="text-base font-semibold">Mutaba'aa — CCHI + Article 144</h3></div>
        <p className="text-sm text-text-secondary">Mandatory employer-paid health insurance with dependent coverage standards. Continuous CCHI compliance scan.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <h3 className="text-base font-semibold mb-3">Death claim — 4-agent coordination</h3>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><AgentBadge agent="tashghil" /> opens the claim, requests beneficiary docs</li>
          <li><AgentBadge agent="mutabaa" /> enforces beneficiary documentation completeness + GOSI death benefit filing</li>
          <li><AgentBadge agent="rawatib" /> computes final settlement to beneficiaries (per Saudi inheritance)</li>
          <li><AgentBadge agent="khidmat" /> notifies + escalates with compassion-mode messaging</li>
        </ul>
      </section>
    </div>
  );
}
